import {createTheme} from "@mui/material";
import {deDE as deDeMuiLocale} from '@mui/material/locale';
import AppFwApp from "../../appfw/ui/AppFwApp.tsx";
import {Branding, Navigation} from "@toolpad/core";
import {
    AccountCircle,
    Event,
    ForwardToInbox,
    HelpOutline,
    PeopleAlt,
    Settings,
    SettingsEthernet, SupportAgent,
    Today,
} from "@mui/icons-material";
import {useAccountOpt} from "./pages/accounts/Accounts.tsx";
import EventerConsoleAccount from "./toolpad/account/EventerConsoleAccount.tsx";
import {EventerConsoleNavigation} from "../EventerConsoleNavigation.tsx";
import {useMemo} from "react";

const theme = createTheme({
        palette: {
            primary: {
                main: "#256377",
            },
        },
    },
    deDeMuiLocale,
)

export default function EventerConsoleApp() {

    const accountOpt = useAccountOpt()

    // TODO: use memo?
    const navigation: Navigation = []

    if (accountOpt) {
        navigation.push(
            {
                segment: EventerConsoleNavigation.accounts.account(accountOpt.id).events.path.substring(1),
                pattern: EventerConsoleNavigation.accounts.accountTemplate().events.path.substring(1),
                title: "Veranstaltungen",
                icon: <Event/>,
            },
            {
                segment: EventerConsoleNavigation.accounts.account(accountOpt.id).importers.path.substring(1),
                pattern: EventerConsoleNavigation.accounts.accountTemplate().importers.path.substring(1),
                title: "Importer",
                icon: <SettingsEthernet/>,
            },

            {
                // segment: "services",
                segment: EventerConsoleNavigation.accounts.account(accountOpt.id).services.path.substring(1),
                title: "Dienste",
                icon: <SupportAgent/>,
                children: [
                    {
                        segment: EventerConsoleNavigation.accounts.account(accountOpt.id).services.emails.segment,
                        // pattern: EventerConsoleNavigation.accounts.accountTemplate().services.emails.path.substring(1),
                        title: "Email senden",
                        icon: <ForwardToInbox/>,
                    },
                ],
            },

            { kind: 'divider', },

            {
                segment: EventerConsoleNavigation.accounts.account(accountOpt.id).help.path.substring(1),
                title: "Hilfe",
                icon: <HelpOutline/>,
                children: [
                    {
                        segment: EventerConsoleNavigation.accounts.account(accountOpt.id).help.gcal.segment,
                        title: "Google Kalender",
                        icon: <Today/>,
                    },
                ],
            },

            {
                segment: EventerConsoleNavigation.accounts.account(accountOpt.id).settings.path.substring(1),
                title: "Einstellungen",
                icon: <Settings/>,

                children: [
                    {
                        segment: EventerConsoleNavigation.accounts.account(accountOpt.id).settings.users.segment,
                        // pattern: EventerConsoleNavigation.accounts.account(accountOpt.id).settings.users.path.substring(1),
                        title: "Nutzer",
                        icon: <PeopleAlt/>,
                    },
                    {
                        segment: EventerConsoleNavigation.accounts.account(accountOpt.id).settings.pod.segment,
                        // pattern: EventerConsoleNavigation.accounts.accountTemplate().settings.pod.path.substring(1),
                        title: "Pod",
                        icon: <AccountCircle/>,
                    },
                ]
            }
        )
    }

    const defaultBranding: Branding = useMemo(() => {
        let branding: Branding = {
            logo: (<></>),
            title: 'Eventer Console',
        }
        if (accountOpt) {
            branding.title = `${accountOpt.podName}`
            branding.homeUrl = EventerConsoleNavigation.accounts.account(accountOpt.id).path
        }
        return branding
    }, [accountOpt])

    return (
        <AppFwApp
            theme={theme}
            defaultBranding={defaultBranding}
            navigation={navigation}
            accountEl={() => <EventerConsoleAccount/>}
        />
    )
}